@if (breadcrumbs.length > 0) {
<div>
  <nav class="orgApp-lp-card-bc-nav">
    @for (breadcrumb of breadcrumbs; track breadcrumb; let isLast=$last) {
    <ng-container>
      <span class="orgApp-lp-card-bc-nav-item orgApp-breadcrumps-item-basic">
        @if (!isLast) {<a
          [routerLink]="breadcrumb.url"
          (click)="onBreadcrumbClick(breadcrumb)"
        >
          @if(breadcrumb?.type!=='location'){
          {{ "toolbar.breadcrumbs." + breadcrumb.label | translate }} } @else{
          {{ breadcrumb.label }} } </a
        >} @if (isLast) {<span class="orgApp-lp-card-bc-nav-l-item">
          @if(breadcrumb?.type!=='location'){
          {{ "toolbar.breadcrumbs." + breadcrumb.label | translate }} } @else{
          {{ breadcrumb.label }} }</span
        >}
      </span>
      @if (!isLast) {
        <svg width="16" height="16" viewBox="0 0 16 16" class="orgApp-margin-left-4 orgApp-margin-right-4">
          <use xlink:href="#arrow-right-light-grey" y="1" x="1"></use>
        </svg>
    } </ng-container
    >}
  </nav>
  <hr class="orgApp-lp-toolbar-border" />
</div>
}
